import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Glyph } from './icon.styles';
import { ICONS_TYPES } from './icon.constants';

export class Icon extends PureComponent {
  static propTypes = {
    borderColor: PropTypes.string,
    className: PropTypes.any,
    color: PropTypes.string,
    inactive: PropTypes.bool,
    name: PropTypes.oneOf(ICONS_TYPES).isRequired,
    size: PropTypes.number,
    stroked: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    size: 24,
  };

  render = () => (
    <Glyph
      name={this.props.name}
      className={this.props.className}
      stroked={this.props.stroked}
      size={this.props.size}
      onClick={this.props.onClick}
      inactive={this.props.inactive}
      color={this.props.color}
      borderColor={this.props.borderColor}
    />
  );
}
